module.exports = __webpack_public_path__ + "img/Aio-Light-Transparent-200px.3578fbf3.png";